import { render, staticRenderFns } from "./SharePermissionsEditor.vue?vue&type=template&id=5e957d09&scoped=true&"
import script from "./SharePermissionsEditor.vue?vue&type=script&lang=js&"
export * from "./SharePermissionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./SharePermissionsEditor.vue?vue&type=style&index=0&id=5e957d09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e957d09",
  null
  
)

export default component.exports